import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import SellIcon from "@mui/icons-material/Sell";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import { motion, AnimatePresence } from "framer-motion";
import { HiHome, HiSparkles, HiChatBubbleLeftRight } from "react-icons/hi2";

const navigationItems = [
  {
    label: "Home",
    icon: <HiHome className="w-6 h-6" />,
    route: "/home",
    color: "text-blue-600"
  },
  {
    label: "Used",
    icon: <DirectionsBikeIcon sx={{ fontSize: "1.5rem" }} />,
    route: "/used-bike-list-router",
    color: "text-green-600"
  },
  {
    label: "New",
    icon: <HiSparkles className="w-6 h-6" />,
    route: "/new-bike-list-router",
    color: "text-purple-600"
  },
  {
    label: "Sell",
    icon: <SellIcon sx={{ fontSize: "1.5rem" }} />,
    route: "/sell-bike",
    color: "text-orange-600"
  },
  {
    label: "Support",
    icon: <HiChatBubbleLeftRight className="w-6 h-6" />,
    route: "/contact",
    color: "text-pink-600"
  }
];

const Footer = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    navigate(navigationItems[newValue].route);
  };

  // Update active tab based on current route
  React.useEffect(() => {
    const currentIndex = navigationItems.findIndex(item => 
      location.pathname.includes(item.route.split('/')[1])
    );
    if (currentIndex !== -1) {
      setValue(currentIndex);
    }
  }, [location.pathname]);

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="fixed bottom-0 left-0 right-0 z-50"
    >
      <div className="bg-white/95 backdrop-blur-lg border-t border-gray-200/50 shadow-strong">
        <BottomNavigation
          showLabels
          value={value}
          onChange={handleNavigation}
          sx={{
            backgroundColor: "transparent",
            "& .MuiBottomNavigationAction-root": {
              color: "#64748b",
              minWidth: "60px",
              padding: "6px 12px 8px",
              "&.Mui-selected": {
                color: "#3b82f6",
                "& .MuiBottomNavigationAction-label": {
                  fontWeight: 600,
                },
              },
              "& .MuiBottomNavigationAction-label": {
                fontSize: "0.7rem",
                fontWeight: 500,
                marginTop: "4px",
                "&.Mui-selected": {
                  fontSize: "0.7rem",
                  fontWeight: 600,
                },
              },
            },
          }}
        >
          {navigationItems.map((item, index) => (
            <BottomNavigationAction
              key={index}
              label={item.label}
              icon={
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ duration: 0.2 }}
                  className={`transition-colors duration-200 ${
                    value === index ? item.color : "text-gray-500"
                  }`}
                >
                  {item.icon}
                </motion.div>
              }
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: "1.4rem",
                },
              }}
            />
          ))}
        </BottomNavigation>
        
        {/* Active indicator */}
        <AnimatePresence>
          <motion.div
            key={value}
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 20, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary-500 to-primary-600 rounded-t-full"
            style={{
              width: `${100 / navigationItems.length}%`,
              left: `${(value * 100) / navigationItems.length}%`,
            }}
          />
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default Footer;
